import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EFPicture from '@elem/ui/ef-picture';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import gtm from '@/utils/gtm';

const Retailers: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('costsaving-new.Retailers');
    let list = [
        {
            src: 'https://websiteoss.ecoflow.com/upload/image/1749621746281/logo1.png',
            link: 'https://www.amazon.com/stores/page/4BFF29AC-A220-4ABD-AFDC-9D612039F6A1',
            data: 'Amazon',
        },
        {
            src: 'https://websiteoss.ecoflow.com/upload/image/1749621746664/logo2.png',
            link: 'https://www.costco.com/s?dept=All&keyword=ecoflow',
            data: 'Costco',
        },
        {
            src: 'https://websiteoss.ecoflow.com/upload/image/1749621746472/logo3.png',
            link: 'https://www.homedepot.com/b/Outdoors-Outdoor-Power-Equipment-Generators-Portable-Power-Stations-Solar-Generators/EcoFlow/N-5yc1vZ2fkoqhpZndu',
            data: 'Homedepot',
        },
        {
            src: 'https://websiteoss.ecoflow.com/upload/image/1749621746947/logo4.png',
            link: 'https://www.lowes.com/pl/generators/portable-power-stations/ecoflow/4294641573-3037501574',
            data: 'Lowes',
        },
        {
            src: 'https://websiteoss.ecoflow.com/upload/image/1749621747856/logo5.png',
            link: 'https://www.bestbuy.com/site/portable-power/solar-generators-power-banks/pcmcat1591109002699.c?id=pcmcat1591109002699&qp=brand_facet%3DBrand~EcoFlow',
            data: 'Bestbuy',
        },
        {
            src: 'https://websiteoss.ecoflow.com/upload/image/1749621747578/logo6.png',
            link: 'https://www.walmart.com/brand/efecoflow/10002573',
            data: 'Walmart',
        },
        {
            src: 'https://websiteoss.ecoflow.com/upload/image/1749621747345/logo7.png',
            link: 'https://www.samsclub.com/b/generators/2040?rootDimension=Brand%3AEcoFlow',
            data: 'Samsclub',
        },
        {
            src: 'https://websiteoss.ecoflow.com/upload/image/1749621747104/logo8.png',
            link: 'https://www.rei.com/search?q=ecoflow',
            data: 'Rei',
        },
    ];
    if (locale === 'ca') {
        list = [
            {
                src: 'https://websiteoss.ecoflow.com/upload/image/1749621746281/logo1.png',
                link: 'https://www.amazon.ca/stores/EFECOFLOW/page/20C3DB9D-74BA-4AE9-93C4-D888FC16B7F4?ref_=ast_bln',
                data: 'Amazon',
            },
            {
                src: 'https://websiteoss.ecoflow.com/upload/image/1749621746664/logo2.png',
                link: 'https://www.costco.ca/s?langId=-24&keyword=EcoFlow',
                data: 'Costco',
            },
            {
                src: 'https://websiteoss.ecoflow.com/upload/image/1749621747856/logo5.png',
                link: 'https://www.bestbuy.com/site/portable-power/solar-generators-power-banks/pcmcat1591109002699.c?id=pcmcat1591109002699&qp=brand_facet%3DBrand~EcoFlow',
                data: 'Bestbuy',
            },
            {
                src: 'https://websiteoss.ecoflow.com/upload/image/1753948139636/Canadian_Tire_logo_2022.png',
                link: 'https://www.canadiantire.ca/en/search-results.html?q=EcoFlow',
                data: 'Canadian Tire',
            },
            {
                src: 'https://websiteoss.ecoflow.com/upload/image/1753948139855/londondrugs.png',
                link: 'https://www.londondrugs.com/search?q=EcoFlow&autoFiltersApplied=true',
                data: 'London Drugs',
            },
            {
                src: 'https://websiteoss.ecoflow.com/upload/image/1753948211501/tsc%20logo.png',
                link: 'https://www.tsc.ca/pages/productresults?dimensions=3004108&rd=1&searchterm=ecoflow ',
                data: 'TSC',
            },
            {
                src: 'https://websiteoss.ecoflow.com/upload/image/1753948138607/batteries%20expert.jpg',
                link: 'https://www.batteriesexpert.com/product_search/?q=EcoFlow',
                data: 'Batteries Expert',
            },
            {
                src: 'https://websiteoss.ecoflow.com/upload/image/1753948138974/shop%20solar.png',
                link: 'https://shopsolarkits.com/collections/ecoflow',
                data: 'Shop Solar',
            },
        ];
    }

    function handleClick(item: any) {
        gtm.push({
            event: 'uaEvent',
            event_name: 'buy_on_retailers',
            listname: t('title'),
            url: item.link,
            sale_platform: item.data,
        });
        window.open(item.link, '_blank');
    }
    return (
        <div
            id="cost-saving-Retailers"
            className={`${styles['cost-saving-Retailers']} cost-saving-Retailers pb-layout GtmModuleData-section`}
            data-section-id={'cost-saving-Retailers'}
            data-section-title={t('title')}
        >
            <div className="page-space"></div>
            <EcoSectionCommon title={t('title')} />
            <div className="logo-wrapper page-layout">
                {list.map((item, index) => (
                    <div className="logo-item" key={index} onClick={() => handleClick(item)}>
                        <EFPicture className={'logo-item-' + (index + 1)} src={item.src} alt={item.src} />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Retailers;
